import { asMultiStyleConfig } from '../../../../utils/theme';
export var DetailsCard = asMultiStyleConfig({
  parts: ['container', 'header', 'footer', 'body'],
  defaultProps: {
    colorScheme: 'idle'
  },
  baseStyle: {
    container: {
      boxSizing: 'border-box',
      borderRadius: 'sm',
      boxShadow: '0 0 12px -8px rgba(0, 0, 0, 0.35)',
      position: 'relative'
    },
    header: {
      display: 'flex',
      borderTopLeftRadius: 'sm',
      borderTopRightRadius: 'sm',
      p: 4
    },
    body: {
      pl: 4,
      pr: 4,
      pb: 4
    },
    footer: {
      p: 4,
      borderBottomLeftRadius: 'sm',
      borderBottomRightRadius: 'sm'
    }
  },
  colorSchemes: {
    idle: {
      container: {
        backgroundColor: 'grey.100',
        border: '1px solid',
        borderColor: 'grey.300'
      },
      footer: {
        bg: 'grey.200'
      }
    },
    focus: {
      container: {
        bg: '#d3e8ff',
        borderColor: '#57A7DA'
      },
      footer: {
        bg: '#cde2f9'
      }
    },
    success: {
      container: {
        bg: 'rgba(238,255,238,0.5)',
        borderColor: 'green.500'
      },
      footer: {
        bg: '#F2FBF2'
      }
    },
    pending: {
      container: {
        bg: 'rgba(255,173,36,0.2)',
        borderColor: 'yellow.500'
      },
      footer: {
        bg: 'rgba(255,173,36,0.2)',
        borderTop: '1px solid',
        borderColor: 'orange.700'
      }
    }
  }
});